export class ActorContentScoped {
    parent;
    scopeType = 'global';
    constructor(parent, scopeType) {
        this.parent = parent;
        this.scopeType = scopeType;
    }
    get actorContent() {
        return this.parent;
    }
    get actor() {
        return this.parent.actor;
    }
    get scope() {
        if (this.scopeType === 'regional') {
            return this.actor.inner.aspectContent.regional;
        }
        return this.actor.inner.aspectContent.global;
    }
    primaryOfKey(key) {
        return this.scope.primaryOfKey(key);
    }
    activeOfKey(key) {
        return this.scope.allActiveOfType(key);
    }
}
